import { FieldFormat, SectionConfig } from "../../types";
import { selectStorageActions } from "../selectors";

const STORAGE_ACTION_TYPE: FieldFormat = {
  enum: {
    NOTHING: "onStorageSuccess.actionType.NOTHING",
    COPY: "onStorageSuccess.actionType.COPY",
    FORWARD: "onStorageSuccess.actionType.FORWARD",
    REJECT: "moreActions.onError.reject",
    DEFAULT: "moreActions.onError.default",
  },
};

const STORAGE_CONTENT: FieldFormat = {
  enum: {
    ORIGINAL: "onStorageSuccess.contentToSend.ORIGINAL",
    PROCESSED: "onStorageSuccess.contentToSend.PROCESSED",
  },
};

const config: SectionConfig = {
  section: "storageActions",
  titleKey: "confirmRuleUpdates.storageActionsChanges.title",
  selector: selectStorageActions,
  properties: {
    onErrorType: {
      label: "confirmRuleUpdates.filepathChanges.onErrorType",
      format: STORAGE_ACTION_TYPE,
    },
    onErrorRecipient: {
      label: "confirmRuleUpdates.filepathChanges.onErrorRecipient",
    },
    onSuccessType: {
      label: "confirmRuleUpdates.filepathChanges.onSuccessType",
      format: STORAGE_ACTION_TYPE,
    },
    onSuccessContent: {
      label: "confirmRuleUpdates.filepathChanges.onSuccessContent",
      format: STORAGE_CONTENT,
    },
    onSuccessRecipient: {
      label: "confirmRuleUpdates.filepathChanges.onSuccessRecipient",
    },
    onSuccessVariable: {
      label: "confirmRuleUpdates.filepathChanges.onSuccessVariable",
      format: { resolve: "variable" },
    },
    aiActionScope: { label: "moreActions.aiAction.scopeLabel" },
  },
};

export default config;
